import { render, staticRenderFns } from "./SlGroups.RelatedOffers.vue?vue&type=template&id=2fc2fb6e&scoped=true&"
import script from "./SlGroups.RelatedOffers.vue?vue&type=script&lang=js&"
export * from "./SlGroups.RelatedOffers.vue?vue&type=script&lang=js&"
import style0 from "./SlGroups.RelatedOffers.vue?vue&type=style&index=0&id=2fc2fb6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc2fb6e",
  null
  
)

export default component.exports